import React from "react";
import Section1 from "../AppointmentForm/Appoint";

const Appointment = () => {
  return (
    <div>
      <Section1 />
    </div>
  );
};

export default Appointment;
